declare var process: any

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT
